let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("clPWs")).then(() => parcelRequire('bp3hM'));